module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "illus"
    }
  }), _vm._v("List of Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate1",
      "id": "plate-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three royal generations: The Queen, Duke of Edinburgh, Prince Charles and Prince William: all dressed up and somewhere to go. © "), _c('em', [_vm._v("Anwar Hussein/Getty Images")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate2",
      "id": "plate-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George V speaks to the empire, ‘from his home and from his heart’, via microphones encased in walnut wood. © "), _c('em', [_vm._v("The Print Collector/Print Collector/Getty Images")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate3",
      "id": "plate-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eighty years on, the Queen’s Christmas broadcast is slightly more informal. © "), _c('em', [_vm._v("John Stillwell – WPA Pool/Getty Images")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate4",
      "id": "plate-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ideal Victorian family: Prince Albert, the Queen and their nine children, an early informal photograph taken at Osborne House, 1857. © "), _c('em', [_vm._v("Royal Collection Trust/Her Majesty Queen Elizabeth II 2015")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate5",
      "id": "plate-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Queen Victoria, portrait by Bassano, 1882: with little tucks here and there to smooth the skin, remove a double chin or two and make the bust more shapely. © "), _c('em', [_vm._v("Alexander Bassano/Spencer Arnold/Getty Images")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate6",
      "id": "plate-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The King who failed: Edward VIII gazes haughtily at the camera. © "), _c('em', [_vm._v("Hirz/Getty Images")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate7",
      "id": "plate-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If the crown fits: George VI and his family on the Buckingham Palace balcony following his coronation in May 1937. His elder daughter Elizabeth (second left in front of her mother) is already perfecting the royal wave. "), _c('em', [_vm._v("© Popperfoto/Getty Images")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate8",
      "id": "plate-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Same balcony seventy-eight years later, different cast, with one notable exception, and only one tentative wave. © "), _c('em', [_vm._v("Keith Hewitt/GC Images")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate9",
      "id": "plate-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A royal duty: happier with his stamps or at the races, King George V nevertheless presents the FA Cup to Manchester City’s captain Sam Cowan in 1934. City had just beaten Portsmouth 2-1. © "), _c('em', [_vm._v("Keystone/Getty Images")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate11",
      "id": "plate-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A willing annual obligation: the Queen looks forward to the racing at Ascot week, in the carriage procession with the Duke. © "), _c('em', [_vm._v("Chris Jackson/Getty Images for Ascot Racecourse")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate12",
      "id": "plate-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alone at the Taj: Diana sends an unsubtle message to the media about the state of her marriage in 1992, shortly before the break up. © "), _c('em', [_vm._v("Anwar Hussein/Wire Image")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate13",
      "id": "plate-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Way Ahead: The Queen takes tea with Mrs Susan McCarron at her Glasgow housing association flat in July 1999. © "), _c('em', [_vm._v("Dave Cheskin/PA Archive/Press Association Images")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate14",
      "id": "plate-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Way Ahead 2: The selfie generation takes a picture: why bother to see the real thing when you can look at her, slightly obscured, on your iPhone later? © "), _c('em', [_vm._v("Peter Macdiarmid – Pool/Getty Images")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate15",
      "id": "plate-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prince Harry is rather more at home with selfies (and paper crowns): in Australia 2015. © "), _c('em', [_vm._v("Chris Jackson/Getty Images")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate16",
      "id": "plate-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William, Kate and Harry (and Beatrice, left) cheer their cousin Zara Phillips on to a silver medal as an eventer at the London Olympics 2012. © "), _c('em', [_vm._v("Carl Court/AFP/Getty Images")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/22_plates#plate17",
      "id": "plate-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Long to reign over us? Prince George, aged sixteen months, sits for his first formal portrait on the steps of Kensington Palace, December 2014. He may not always find the camera so friendly. © "), _c('em', [_vm._v("The Duke and Duchess of Cambridge/PA Wire via Getty Images")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74ea2e9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05a_illustrations.vue
// module id = 72
// module chunks = 0